import React from "react";
import {
  Svg,
  Line,
  Polyline,
  Polygon,
  Path,
  Rect,
  Circle,
  Ellipse,
  Text,
  Tspan,
  G,
  Stop,
  ClipPath,
  LinearGradient,
  RadialGradient,
} from "@react-pdf/renderer";

export const Pied = ({color} : {color: string}) => {
  // @ts-ignore
  return (<Svg id="Calque_1" data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 54.7 82.2">
  <G fill={color}>
    <Path d="M28.4,13.77c-.99-.19-2.05-.33-3.13-.4-1.18-.08-2.34-.03-3.47.13-9.88,1.45-14.65,11.92-14.61,17.53-.1,1.25-.55,8.91,1.04,24.94,1.68,16.9,7.02,25.72,15.88,26.22.27.01.53.02.79.02,7.62,0,12.81-6.21,13.49-12.46.37-3.4-.84-5.96-1.9-8.22-.69-1.48-1.35-2.87-1.61-4.51-.1-.63-.14-1.25-.11-1.92.03-.83.14-1.62.34-2.43.64-2.6,2.09-4.77,3.38-6.68.78-1.16,1.51-2.25,2.03-3.37,1.31-2.83,2.94-7.34,1.95-13.87-.72-4.71-3.5-12.92-14.07-14.98Z"/>
    <Path d="M8.27,13.84h0c-1.77-2.04-4.79-2.33-6.73-.64-1.93,1.68-2.07,4.71-.3,6.75,1,1.15,2.39,1.74,3.76,1.74,1.07,0,2.12-.36,2.97-1.1,1.94-1.68,2.07-4.71.3-6.75Z"/>
    <Path d="M13.33,14.62c.68,0,1.37-.15,2.02-.45,2.48-1.18,3.48-4.28,2.23-6.93-.57-1.2-1.54-2.16-2.72-2.68-1.32-.58-2.79-.57-4.05.02-1.26.6-2.21,1.74-2.59,3.13-.34,1.25-.22,2.6.36,3.8.92,1.95,2.82,3.11,4.75,3.11Z"/>
    <Path d="M23.84,11.01c.13,0,.27,0,.4-.02,2.78-.24,4.82-2.9,4.56-5.92h0C28.54,2.04,26.05-.24,23.29.02c-2.78.24-4.82,2.9-4.56,5.92.12,1.36.68,2.62,1.6,3.55.95.98,2.22,1.52,3.51,1.52Z"/>
    <Path d="M32.91,12.1c.49.16,1,.24,1.51.24.94,0,1.88-.27,2.72-.79,1.15-.71,2.02-1.84,2.46-3.18.96-2.95-.48-6.06-3.2-6.95-1.4-.46-2.94-.26-4.23.55-1.15.71-2.02,1.84-2.45,3.17-.44,1.34-.4,2.76.11,4.01.57,1.41,1.7,2.49,3.09,2.94Z"/>
    <Path d="M52.3,5.23c-1.58-1.17-3.67-1.44-5.74-.75-1.73.57-3.35,1.78-4.54,3.4-1.2,1.62-1.88,3.52-1.92,5.34-.05,2.18.82,4.1,2.4,5.27,1.04.76,2.25,1.13,3.5,1.13,2.4,0,4.97-1.34,6.78-3.78h0c1.2-1.62,1.88-3.52,1.92-5.34.05-2.18-.82-4.1-2.4-5.27Z"/>
  </G>
</Svg>
);
};

export default Pied;
